import '../assets/NcIconToggleSwitch-saytabt5.css';
import { defineComponent, useCssVars, computed, createBlock, openBlock, normalizeClass } from "vue";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-BvLanNaW.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const svg = `<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 12">
	<path d="M17,1H7A5,5 0 0,0 2,6 5,5 0 0,0 7,11H17A5,5 0 0,0 22,6 5,5 0 0,0 17,1Z" />
	<circle
		cy="6"
		r="3"
		fill="var(--color-main-background)" />
</svg>`;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcIconToggleSwitch",
  props: {
    checked: { type: Boolean },
    size: { default: 34 },
    inline: { type: Boolean, default: false }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "6bd152af": color.value,
      "16fd8ca9": cx.value
    }));
    const color = computed(() => __props.checked ? "var(--color-primary-element)" : "var(--color-text-maxcontrast)");
    const cx = computed(() => __props.checked ? "calc(17 / 24 * 100%)" : "calc(7 / 24 * 100%)");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcIconSvgWrapper, {
        class: normalizeClass(_ctx.$style.iconToggleSwitch),
        svg,
        size: _ctx.size,
        inline: _ctx.inline
      }, null, 8, ["class", "size", "inline"]);
    };
  }
});
const iconToggleSwitch = "_iconToggleSwitch_WgcOx";
const style0 = {
  "material-design-icon": "_material-design-icon_ZYrc5",
  iconToggleSwitch
};
const cssModules = {
  "$style": style0
};
const NcIconToggleSwitch = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcIconToggleSwitch as N
};
//# sourceMappingURL=NcIconToggleSwitch-CSrdR61T.mjs.map
